import React from 'react';

// Issue #418: When `onRestore` is provided, the row is treated as already
// auto-deleted (e.g. content removed after 5+ reports). The "Löschen" button
// is hidden and replaced by "Wiederherstellen" so admins are not misled into
// trying to delete content that is already gone.
function RowActionButtons({ onView, onDelete, onRestore }) {
  return (
    <>
      {onView && (
        <button
          type="button"
          onClick={onView}
          className="action-btn view row-action-btn"
          title="Details anzeigen"
        >
          👁️
        </button>
      )}
      {onRestore ? (
        <button
          type="button"
          onClick={onRestore}
          className="action-btn activate row-action-btn"
          title="Wiederherstellen"
        >
          ↩
        </button>
      ) : onDelete && (
        <button
          type="button"
          onClick={onDelete}
          className="action-btn delete row-action-btn"
          title="Löschen"
        >
          🗑️
        </button>
      )}
    </>
  );
}

export default RowActionButtons;
